<template>
    <pendo-multiselect
        class="ask-pendo-artifact-multiselect"
        :options="items"
        :value="activeItem"
        @select="$emit('select', $event)">
        <template #trigger="{ comboboxAttrs, handleKeydown, toggleMenu }">
            <div
                v-bind="comboboxAttrs"
                class="ask-pendo-artifact-multiselect__trigger"
                @click="toggleMenu"
                @keydown="handleKeydown">
                <pendo-icon
                    :type="triggerIcon"
                    size="16" />
                <span>{{ triggerText }}</span>
                <pendo-icon
                    type="chevron-down"
                    size="16" />
            </div>
        </template>
        <template #option="{ option }">
            <div class="ask-pendo-artifact-multiselect__item">
                <pendo-icon
                    :type="option.icon"
                    size="16" />
                <span>{{ option.label }}</span>
            </div>
        </template>
    </pendo-multiselect>
</template>

<script>
import { PendoIcon, PendoMultiselect } from '@pendo/components';

export default {
    name: 'AskPendoArtifactMultiselect',
    components: {
        PendoIcon,
        PendoMultiselect,
    },
    props: {
        activeItemId: {
            type: String,
            default: null,
        },
        items: {
            type: Array,
            required: true,
        },
    },
    emits: ['select'],
    computed: {
        activeItem () {
            return this.activeItemId ? this.items.find((item) => item.id === this.activeItemId) : null;
        },
        triggerText () {
            return this.activeItem?.label || this.$t('askPendo.artifactMultiselect.Choose an artifact');
        },
        triggerIcon () {
            return this.activeItem?.icon || 'sparkles';
        },
    },
};
</script>

<style scoped lang="less">
.ask-pendo-artifact-multiselect {
    &__trigger {
        display: flex;
        align-items: center;
        gap: 8px;

        color: var(--palette-gray-100);
        font-weight: 600;

        margin-left: -8px;
        padding: 4px 8px;
        border-radius: 3px;
        cursor: pointer;

        transition: outline 0.1s cubic-bezier(0.25, 0.1, 0.25, 1), color 0.2s, background-color 0.2s, border-color 0.2s;

        &:hover {
            background-color: var(--palette-gray-30);
        }
    }

    &__item {
        display: flex;
        align-items: stretch;
        gap: 8px;

        padding: 4px 0;

        color: var(--palette-gray-100);
        max-width: 400px;
        line-height: initial;

        span {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
}
</style>
